import { FacilityAssetsData } from "../FacilityAssets/FacilityAssetsWithStoreWithData"
import LowBatteryReport from "."

const LowBatteryReportWithData = FacilityAssetsData(LowBatteryReport)

export default LowBatteryReportWithData
